const dummyInvoices = Array.from({ length: 200 }, (_, i) => {
    const kenyanNames = [
      "James Mwangi", "Mary Wanjiru", "Joseph Kamau", "Grace Nyambura", "John Njoroge",
      "Margaret Achieng", "David Kipchumba", "Catherine Ndungu", "Peter Otieno", "Anne Wairimu",
      "Samuel Wekesa", "Dorothy Muthoni", "Daniel Mbugua", "Lilian Atieno", "Michael Njenga",
      "Esther Chebet", "Alex Kimani", "Betty Waithera", "Kevin Kiprono", "Nancy Wambui"
    ];
  
    const year = i < 100 ? 2024 : 2025; // First 100 for 2024, next 100 for 2025
    const month = (i % 12) + 1;
    const day = (i % 28) + 1;
  
    return {
      id: i + 1,
      tenant: kenyanNames[i % kenyanNames.length],
      houseNumber: `H${100 + i}`,
      rent: Math.floor(Math.random() * 10000) + 20000, // Rent between 20,000 - 30,000
      tax: Math.floor(Math.random() * 5000) + 2000, // Tax between 2,000 - 7,000
      invoiceDate: `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`,
    };
  });
  
  export default dummyInvoices;
  